import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\GetModelNotificationListController::__invoke
* @see app/Http/Controllers/ModelNotification/GetModelNotificationListController.php
* @route '/api/model-notification/path/{path}'
*/
const GetModelNotificationListController = (args: { path: string | number } | [path: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetModelNotificationListController.url(args, options),
    method: 'post',
})

GetModelNotificationListController.definition = {
    methods: ["post"],
    url: '/api/model-notification/path/{path}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ModelNotification\GetModelNotificationListController::__invoke
* @see app/Http/Controllers/ModelNotification/GetModelNotificationListController.php
* @route '/api/model-notification/path/{path}'
*/
GetModelNotificationListController.url = (args: { path: string | number } | [path: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { path: args }
    }

    if (Array.isArray(args)) {
        args = {
            path: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        path: args.path,
    }

    return GetModelNotificationListController.definition.url
            .replace('{path}', parsedArgs.path.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\GetModelNotificationListController::__invoke
* @see app/Http/Controllers/ModelNotification/GetModelNotificationListController.php
* @route '/api/model-notification/path/{path}'
*/
GetModelNotificationListController.post = (args: { path: string | number } | [path: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetModelNotificationListController.url(args, options),
    method: 'post',
})

export default GetModelNotificationListController